import moment from "moment";
import { isNumberNotEmpty } from "../../utils/helpers";

const getPrevFpsStartDate = (
  newStudyPlanValues,
  predecessorCohortName,
  predecessorActivity,
  columnHeader3,
  columnHeader4,
) => {
  const prevCohort = newStudyPlanValues.filter(
    (nsv) => nsv.cohortName && nsv.cohortName === predecessorCohortName,
  );
  
  if (!prevCohort.length) return null;
  
  const cohort = prevCohort[0];
  
  // Determine the activity end key based on the predecessor activity
  let activityEndKey = "";
  
  if (predecessorActivity === "Screening") {
    activityEndKey = "screeningEndDate";
  } else if (predecessorActivity === "Enrolling") {
    activityEndKey = "enrollingEndDate";
  } else if (predecessorActivity === columnHeader3) {
    activityEndKey = "dtlEndDate";
  } else if (predecessorActivity === columnHeader4) {
    activityEndKey = "srcEndDate";
  }
  
  if (!activityEndKey || !cohort[activityEndKey]) return null;
  
  return cohort[activityEndKey];
};

export const updateCalculatedFields = (
  newStudyPlanValues,
  fpsStartDate,
  croStartDate,
  columnHeader3 = "DLT",
  columnHeader4 = "SRC",
) => {
  const lNewStudyPlanValues = [...newStudyPlanValues];
  return newStudyPlanValues.map((npv, index) => {
    const lFpsStartDate =
      index === 0
        ? fpsStartDate
        : getPrevFpsStartDate(
            lNewStudyPlanValues,
            lNewStudyPlanValues[index].predecessorCohortName,
            lNewStudyPlanValues[index].predecessorActivity,
            columnHeader3,
            columnHeader4,
          );
    if (!lFpsStartDate) return npv;
    const cohortStartDate =
      !isNaN(npv.lagDays) && lFpsStartDate
        ? moment
            .utc(lFpsStartDate, "D/MMM/YY")
            .add(npv.lagDays, "days")
            .format("D-MMM-YY")
        : "";
    const cohortStartDay =
      cohortStartDate && croStartDate
        ? Math.abs(
            moment
              .utc(cohortStartDate, "D-MMM-YY")
              .diff(moment.utc(croStartDate, "D/MMM/YY"), "days"),
          )
        : "";

    const screeningEndDate =
      cohortStartDate && isNumberNotEmpty(npv.screeningDurationDays)
        ? moment
            .utc(cohortStartDate, "D-MMM-YY")
            .add(npv.screeningDurationDays, "days")
            .format("D-MMM-YY")
        : "";
    const screeningStudyDay =
      screeningEndDate && croStartDate
        ? Math.abs(
            moment
              .utc(screeningEndDate, "D-MMM-YY")
              .diff(moment.utc(croStartDate, "D/MMM/YY"), "days"),
          )
        : "";
    const enrollingEndDate =
      screeningEndDate && isNumberNotEmpty(npv.enrollingDurationDays)
        ? moment
            .utc(screeningEndDate, "D-MMM-YY")
            .add(npv.enrollingDurationDays, "days")
            .format("D-MMM-YY")
        : "";
    const enrollingEndDay =
      enrollingEndDate && croStartDate
        ? Math.abs(
            moment
              .utc(enrollingEndDate, "D-MMM-YY")
              .diff(moment.utc(croStartDate, "D/MMM/YY"), "days"),
          )
        : "";
    const dtlEndDate =
      enrollingEndDate && isNumberNotEmpty(npv.dtlDurationDays)
        ? moment
            .utc(enrollingEndDate, "D-MMM-YY")
            .add(npv.dtlDurationDays, "days")
            .format("D-MMM-YY")
        : "";
    const dtlEndDay =
      dtlEndDate && croStartDate
        ? Math.abs(
            moment
              .utc(dtlEndDate)
              .diff(moment.utc(croStartDate, "D/MMM/YY"), "days"),
          )
        : "";
    const srcEndDate =
      dtlEndDate && isNumberNotEmpty(npv.srcDurationDays)
        ? moment
            .utc(dtlEndDate, "D-MMM-YY")
            .add(npv.srcDurationDays, "days")
            .format("D-MMM-YY")
        : "";
    const srcEndDay =
      srcEndDate && croStartDate
        ? Math.abs(
            moment
              .utc(srcEndDate)
              .diff(moment.utc(croStartDate, "D/MMM/YY"), "days"),
          )
        : "";
    const newNpv = {
      ...npv,
      cohortStartDate: cohortStartDate,
      cohortStartDay: cohortStartDay,
      screeningEndDate: screeningEndDate,
      screeningEndDay: screeningStudyDay,
      enrollingEndDate: enrollingEndDate,
      enrollingEndDay: enrollingEndDay,
      dtlEndDate: dtlEndDate,
      dtlEndDay: dtlEndDay,
      srcEndDate: srcEndDate,
      srcEndDay: srcEndDay,
    };
    lNewStudyPlanValues[index] = newNpv;
    return newNpv;
  });
};
